import { Button } from '@/common/components';
import { styled } from '@/stitches.config';
import { TFunction } from 'i18next';

const RootContainer = styled('section', {
  boxShadow: '$studyInsights$shadowBox',
  // This is the value from the figma file
  height: '500px',
  borderRadius: '$8',
});

const ContentContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$8',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

const Title = styled('span', {
  textAlign: 'center',
  color: '$darkGray600',
  fontSize: '$lg',
  fontWeight: '$bold',
});

const Description = styled('span', {
  textAlign: 'center',
  color: '$darkGray300',
  fontSize: '$lg',
  // Fixed width from the figma file
  maxWidth: '424px',
  fontWeight: '$medium',
});

interface NoActiveCampaignsBoxProps {
  t: TFunction;
  onOpenCreateCampaignModal?: () => void;
}

export const NoActiveCampaignsBox = ({ t, onOpenCreateCampaignModal }: NoActiveCampaignsBoxProps): JSX.Element => {
  return (
    <RootContainer>
      <ContentContainer>
        <Title>{t('add_campaign.no_active_campaigns.title')}</Title>
        <Description>{t('add_campaign.no_active_campaigns.description')}</Description>
        {/* Padding is out of convention in here, this is a one time button */}
        <Button onClick={onOpenCreateCampaignModal} css={{ padding: '24px 48px' }}>
          {t('add_campaign.no_active_campaigns.button')}
        </Button>
      </ContentContainer>
    </RootContainer>
  );
};
